export const tableHeadConfig = [
  { id: 1, label: 'ID', isSortable: false },
  { id: 2, label: 'Location', isSortable: true, parameter: 'location.siteCode' },
  { id: 3, label: 'Job Number', isSortable: false },
  { id: 4, label: 'Project Number', isSortable: true, parameter: 'jobNumber' },
  { id: 5, label: 'Created By', isSortable: true, parameter: 'createdByUser.firstName' },
  { id: 6, label: 'Created', isSortable: true, parameter: 'createdAtUtc' },
  { id: 7, label: 'Submitted By', isSortable: true, parameter: 'submittedByUser.firstName' },
  { id: 8, label: 'Report name', isSortable: true, parameter: 'generalReportTemplate.name' },
  { id: 9, label: 'Report note', isSortable: false },
  { id: 10, label: 'PDF Report', isSortable: false }
];
